import React from "react";
import StatusBadge from "@/components/StatusBadge";

export const columns = () => {
  return [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "code",
      header: "ID",
      cell: ({ row }) => <div>{row.getValue("code")}</div>,
    },
  ];
};
